const Cross = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_3805_2407)">
        <path
          d="M2.93008 17.0718C1.97498 16.1493 1.21316 15.0459 0.689065 13.8258C0.164975 12.6058 -0.110887 11.2936 -0.122425 9.9658C-0.133963 8.63801 0.119054 7.32121 0.621863 6.09225C1.12467 4.86328 1.8672 3.74677 2.80613 2.80784C3.74506 1.86891 4.86158 1.12638 6.09054 0.623572C7.3195 0.120763 8.6363 -0.132254 9.96409 -0.120716C11.2919 -0.109178 12.6041 0.166684 13.8241 0.690774C15.0442 1.21486 16.1476 1.97669 17.0701 2.93179C18.8917 4.81781 19.8996 7.34383 19.8768 9.9658C19.854 12.5878 18.8023 15.0959 16.9483 16.95C15.0942 18.8041 12.5861 19.8557 9.96409 19.8785C7.34212 19.9013 4.8161 18.8934 2.93008 17.0718ZM11.4001 10.0018L14.2301 7.17179L12.8201 5.76179L10.0001 8.59179L7.17008 5.76179L5.76008 7.17179L8.59008 10.0018L5.76008 12.8318L7.17008 14.2418L10.0001 11.4118L12.8301 14.2418L14.2401 12.8318L11.4101 10.0018H11.4001Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_3805_2407">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default Cross;
